import { useState } from 'react';
import { record } from "@solimat/solimat-web-endpoint";

type StatusSolicitudGastosContingenciaProfesional = {
  status: number | null;
  statusText: string | null;
};

const useGetSolicitudGastosContingenciaProfesionalItByUser = () => {
  const [loadingGetSolicitudGastosContingenciaProfesionalItByUser, setLoadingGetSolicitudGastosContingenciaProfesionalItByUser] = useState(false);
  const [successGetSolicitudGastosContingenciaProfesionalItByUser, setSuccessGetSolicitudGastosContingenciaProfesionalItByUser] = useState(false);
  const [errorGetSolicitudGastosContingenciaProfesionalItByUser, setErrorGetSolicitudGastosContingenciaProfesionalItByUser] = useState<any>(null);
  const [dataGetSolicitudGastosContingenciaProfesionalItByUser, setDataSolicitudGastosContingenciaProfesionalItByUser] = useState<any>(null);
  const [statusGetSolicitudGastosContingenciaProfesionalItByUser, setStatusGetSolicitudGastosContingenciaProfesionalItByUser] =
    useState<StatusSolicitudGastosContingenciaProfesional>({
      status: null,
      statusText: null
    });

  const BASE_URL = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_PATH || "";
  const FUNCTIONS_KEY = import.meta.env.VITE_REACT_APP_PRESTACIONES_PACIENTE_KEY || "";
  const apirecord = new record.RecordService(BASE_URL, FUNCTIONS_KEY);

  // GET
  const getSolicitudGastosContingenciaProfesionalItByUser = async (
    userId: string, expedienteId: string,
    tipoGastos: number,
    _cb?: (data: any) => void
  ) => {
    setLoadingGetSolicitudGastosContingenciaProfesionalItByUser(true);
    setSuccessGetSolicitudGastosContingenciaProfesionalItByUser(false);
    setErrorGetSolicitudGastosContingenciaProfesionalItByUser(null);

    try {
      const res = await apirecord.getSolicitudGastosContingenciaProfesionalItByUser(userId, tipoGastos, expedienteId);

      setStatusGetSolicitudGastosContingenciaProfesionalItByUser({
        status: res.status,
        statusText: res.statusText
      });

      setDataSolicitudGastosContingenciaProfesionalItByUser(res.data);
      setSuccessGetSolicitudGastosContingenciaProfesionalItByUser(true);

      if (typeof _cb === "function") {
        _cb(res.data);
      }

      return res.data;

    } catch (err: any) {

      setStatusGetSolicitudGastosContingenciaProfesionalItByUser({
        status: err?.response?.status || 500,
        statusText: err?.response?.statusText || "Error"
      });

      setErrorGetSolicitudGastosContingenciaProfesionalItByUser(err);
      console.error("Error en getSolicitudGastosContingenciaProfesionalItByUser:", err);

      throw err;

    } finally {
      setLoadingGetSolicitudGastosContingenciaProfesionalItByUser(false);
    }
  };

  return {
    getSolicitudGastosContingenciaProfesionalItByUser,
    loadingGetSolicitudGastosContingenciaProfesionalItByUser,
    successGetSolicitudGastosContingenciaProfesionalItByUser,
    errorGetSolicitudGastosContingenciaProfesionalItByUser,
    dataGetSolicitudGastosContingenciaProfesionalItByUser,
    statusGetSolicitudGastosContingenciaProfesionalItByUser
  };
};

export default useGetSolicitudGastosContingenciaProfesionalItByUser;